<template>
  <div>
    <v-bottom-navigation
      color="info"
      horizontal
      :background-color="colorfrist"
      dark
      height="40px"
    >
      <v-btn to="/admin/timelines/examination_deputyDirector" class="mr-5">
        <span>กำหนดการ รอง ผอ.</span>
        <v-icon>mdi-numeric-1-box</v-icon>
      </v-btn>
     
      <v-btn to="/admin/sedirector_app" class="mr-5">
        <span>ข้อมูลผู้สมัคร</span>
        <v-icon>mdi-numeric-2-box</v-icon>
      </v-btn>

      <v-btn to="/admin/sedirector_assessment/sedirector_app_a" class="mr-5">
        <span>วท. ภาค ก.</span>
        <v-icon>mdi-numeric-3-box</v-icon>
      </v-btn>

      <v-btn to="/admin/sedirector_assessment/sedirector_app_b" class="mr-5">
        <span>สอจ. ภาค ข.</span>
        <v-icon>mdi-numeric-4-box</v-icon>
      </v-btn>

      <v-btn to="/admin/sedirector_assessment/sedirector_app_c" class="mr-5">
        <span>กจ2. ภาค ค.</span>
        <v-icon>mdi-numeric-5-box</v-icon>
      </v-btn>


    </v-bottom-navigation>

    <v-bottom-navigation
      color="info"
      horizontal
      :background-color="colorsecond"
      dark
      height="40px"
    >
    <v-btn to="/admin/sedirector_assessment/sedirector_app_notice" class="mr-5">
        <span>ประกาศผล</span>
        <v-icon>mdi-numeric-6-box</v-icon>
      </v-btn>

      <v-btn to="/admin/sedirector_assessment/director_college_manpower" class="mr-5">
        <span>ตำแหน่งว่างสถานศึกษา</span>
        <v-icon>mdi-numeric-7-box</v-icon>
      </v-btn>

      
      <v-btn to="/admin/sedirector_assessment/sedirector_app_choose" class="mr-5">
        <span>การรายงานตัวเลือกสถานศึกษา</span>
        <v-icon>mdi-numeric-8-box</v-icon>
      </v-btn>

      <v-btn to="/admin/sedirector_assessment/sedirector_app_report_college" class="mr-5">
        <span>การรายงาน ณ สถานศึกษา</span>
        <v-icon>mdi-numeric-9-box</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: "HRvecPersonnelmenu",

  data() {
    return {
      personnels: false
    };
  },

  mounted() {},

  methods: {
    async personnelselect() {
      this.personnels = true;
    }
  },
  computed: {
    colorfrist() {
      return "#414141";
    },
    colorsecond() {
      return "#2e7d32";
    },
  }
};
</script>

<style lang="scss" scoped></style>
